<ng-container *ngIf="loadedTasksIds.length > 0">
  <div class="left" *ngIf="isSelectAllChecked || isSelectAllIndeterminate">
    <button mat-raised-button color="primary" (click)="cancel()" translate="cancel"></button>
    <div>
      {{ massActionsService.idsSelection.length }}

      <span
        [innerHtml]="
          'inbox/task-list/mass-actions/messages-selected'
            | translate: { state: '<span class=\'uppercase\'>' + state + '</span>' }
        "></span>
    </div>

    <ng-container
      *ngIf="
        massActionsService.idsSelection.length !== tasksIds.length &&
        massActionsService.idsSelection.length !== selectionLimit
      ">
      <ng-container *ngIf="tasksIds.length <= selectionLimit; else overLimit">
        <a (click)="selectAllTasks()"
          ><span translate="inbox/task-list/mass-actions/select-all"></span> {{ this.tasksIds.length }}</a
        >
      </ng-container>

      <ng-template #overLimit>
        <a (click)="selectAllTasks()"
          ><span
            translate="inbox/task-list/mass-actions/select-all-limit"
            [translateParams]="{ limit: selectionLimit }"></span>
          {{ this.tasksIds.length }}</a
        >
      </ng-template>
    </ng-container>
  </div>

  <div class="right">
    <ng-container *ngIf="isSelectAllChecked || isSelectAllIndeterminate">
      <button
        *ngIf="isAlcmeonUser"
        mat-raised-button
        color="primary"
        (click)="answer()"
        [disabled]="massActionsService.idsSelection.length > answerLimit || !hasOnlyOneSiteTypeSelected"
        [matTooltip]="
          massActionsService.idsSelection.length > answerLimit
            ? ('inbox/task-list/mass-actions/answer/tooltip/max' | translate: { nb: answerLimit })
            : !hasOnlyOneSiteTypeSelected
            ? ('inbox/task-list/mass-actions/answer/tooltip/channel' | translate)
            : ''
        "
        translate="inbox/task-list/mass-actions/answer/button"
        data-testid="archive-all-selected"></button>

      <button
        mat-raised-button
        color="primary"
        (click)="archive()"
        translate="inbox/task-list/mass-actions/archive/button"
        data-testid="archive-all-selected"></button>

      <button
        mat-raised-button
        color="primary"
        (click)="export()"
        translate="inbox/task-list/mass-actions/export/button"></button>
    </ng-container>

    <mat-checkbox
      color="primary"
      *ngIf="!isSelectAllDisabled"
      [indeterminate]="isSelectAllIndeterminate"
      [(ngModel)]="isSelectAllChecked"
      (ngModelChange)="selectLoadedTasks($event)"
      [matTooltip]="'inbox/task-list/mass-actions/checkbox' | translate"
      data-testid="select-all-displayed"></mat-checkbox>
  </div>
</ng-container>
